import { lazy, type FC } from 'react';
import type { DatePickerProps, RangePickerProps } from 'antd/es/date-picker';
import type { TimePickerProps } from 'antd/es/time-picker';

// rc-picker is ~200 kB and most sessions never open a date field, so the antd pickers are
// pulled in on demand. Declared once here: two lazy() calls over the same module would be
// two components loading the same chunk.
//
// lazy() erases antd's dayjs generic binding, so each props type is restated on the cast.
export const LazyAntDatePicker = lazy(
  () => import('antd/es/date-picker')
) as unknown as FC<DatePickerProps>;

export const LazyAntRangePicker = lazy(() =>
  import('antd/es/date-picker').then((m) => ({
    default: m.default.RangePicker,
  }))
) as unknown as FC<RangePickerProps>;

export const LazyAntTimePicker = lazy(
  () => import('antd/es/time-picker')
) as unknown as FC<TimePickerProps>;
